import { faker } from '@faker-js/faker';
import React, {useState, useEffect, useCallback, useContext} from 'react';
import { Helmet } from 'react-helmet-async';
import {useNavigate} from 'react-router-dom';
// @mui
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
  TextField,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  Chip,
  useTheme,
  useMediaQuery
} from '@mui/material';

import { camelCase } from 'lodash'

// components
import Iconify from '../iconify';
import Scrollbar from '../scrollbar';
// sections
import { EnvelopeListHead, EnvelopeListToolbar } from '../../sections/@dashboard/envelope/index';

import GroupCard from './GroupCard'

import { EntityContext } from '../../entity';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Nome', alignRight: false },
  { id: 'signersNumber', label: 'Assinantes', alignRight: false },
  { id: 'signersMinimum', label: 'Minimo de assinantes', alignRight: false },
  { id: 'signatureType', label: 'Tipo de assinatura', alignRight: false },
  { id: 'action', label: '', alignRight: false },
];

const TABLE_HEAD_SIMPLE = [
  { id: 'name', label: 'Nome', alignRight: false },
  { id: 'signersNumber', label: 'Assinantes', alignRight: false },
  { id: 'signersMinimum', label: 'Minimo de assinantes', alignRight: false },
  { id: 'signatureType', label: 'Tipo de assinatura', alignRight: false },
  { id: 'action', label: '', alignRight: false },
];


export default function GroupList(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

    const [page, setPage] = useState(0);

    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [signerList, setSignerList] = useState([])

    const [groupName, setGroupName] = useState('')
    const [signerDocumentNumber, setSignerDocumentNumber] = useState('')
    const [signerEmail, setSignerEmail] = useState('')

	const envelopeKey = props.envelopeKey

  const { getEnvelope, getGroupByName, VinculateGroupToEnvelope, sendToSignature, DeleteGroupFromEnvelope } = useContext(EntityContext)

  const navigateToDone = () => {
    // 👇️ navigate to /contacts
    navigate('/dashboard/done');
  };

  useEffect(() => {
    getSigners()
    }, [])

	const camelizeKeys = (obj) => {

		let finalResponse = obj

		if (Array.isArray(obj)) {
			finalResponse = obj.map(v => camelizeKeys(v));
		} else if (obj != null && obj.constructor === Object) {
			finalResponse = Object.keys(obj).reduce(
			(result, key) => ({
			  ...result,
			  [camelCase(key)]: camelizeKeys(obj[key]),
			}),
			{},
		  );
		}
		return finalResponse;
	  };
	
    const getSigners = useCallback(async () => {
	
      getEnvelope(envelopeKey)
      .then((data) => {
        
        setSignerList(data.groups)
      })
	
	  }, [])

	  const vinculateSignerToEnvelope = async (groupNameToCheck, signatureType) =>
      getGroupByName(groupNameToCheck)
      .then((data) => VinculateGroupToEnvelope(envelopeKey, data.group.group_key, signatureType)
        .then((data) => {
          
          getSigners()
          return data
        }))

    const handleGroupRemove = async(groupKey) => {

      DeleteGroupFromEnvelope(envelopeKey, groupKey)
      .then((data) => {
        getSigners()
      })

    }

	  const sendToSignatureButton = async () => {

      if (signerList.length === 0) {

        props.changeStep(2)
  
      } else {

        sendToSignature(envelopeKey)
        .then((data) => {
          if (props.onEnvelopeSent) {
            props.onEnvelopeSent();
          } else {
            props.changeStep(3);
          }
        })

      }
		
	  }

    const previousStep = async () => {
        props.changeStep(1)
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setPage(0);
        setRowsPerPage(parseInt(event.target.value, 10));
    };

    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - signerList.length) : 0;

    return (
        <>
        <Box>
            {/* Botões de ação - responsivos */}
            <Stack 
                direction={{ xs: 'column', sm: 'row' }} 
                spacing={2}
                alignItems={{ xs: 'stretch', sm: 'center' }}
                justifyContent="space-between" 
                mb={3}
            >
                <Button 
                    variant="contained"
                    onClick={previousStep}
                    fullWidth={isMobile}
                    sx={{ 
                        minWidth: { xs: '100%', sm: 'auto' },
                        whiteSpace: 'nowrap'
                    }}
                >
                    Revisar documentos
                </Button>
                <Button 
                    variant="contained"
                    onClick={_ => sendToSignatureButton()}
                    fullWidth={isMobile}
                    sx={{ 
                        minWidth: { xs: '100%', sm: 'auto' },
                        whiteSpace: 'nowrap'
                    }}
                >
                    Enviar para assinatura
                </Button>
            </Stack>

            <GroupCard vinculateSignerToEnvelope={vinculateSignerToEnvelope}/>

            <Box sx={{ width: '100%' }}>
                <Card>
                    {isMobile ? (
                        // Vista mobile: Cards sem checkbox, busca e filtro
                        <>
                            <Box sx={{ p: 2 }}>
                                {signerList.length === 0 ? (
                                    <Stack alignItems="center" spacing={2} py={4}>
                                        <Iconify icon="eva:people-outline" sx={{ fontSize: 48, color: 'text.disabled' }} />
                                        <Typography variant="body2" color="text.secondary" align="center">
                                            Nenhum grupo de assinantes adicionado ainda
                                        </Typography>
                                    </Stack>
                                ) : (
                                    <List>
                                        {signerList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                                            return (
                                                <React.Fragment key={row.group_key}>
                                                    <ListItem
                                                        sx={{
                                                            borderRadius: 1,
                                                            mb: 1,
                                                            border: '1px solid',
                                                            borderColor: 'divider',
                                                            flexDirection: 'column',
                                                            alignItems: 'flex-start',
                                                            bgcolor: 'background.paper'
                                                        }}
                                                    >
                                                        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', mb: 1 }}>
                                                            <ListItemText
                                                                primary={
                                                                    <Typography variant="subtitle2" fontWeight="bold">
                                                                        {row.group_name}
                                                                    </Typography>
                                                                }
                                                            />
                                                            <ListItemSecondaryAction>
                                                                <IconButton 
                                                                    edge="end" 
                                                                    color="error" 
                                                                    onClick={_ => handleGroupRemove(row.group_key)}
                                                                    size="small"
                                                                >
                                                                    <Iconify icon={'eva:trash-2-outline'} />
                                                                </IconButton>
                                                            </ListItemSecondaryAction>
                                                        </Box>
                                                        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
                                                            <Typography variant="body2" color="text.secondary">
                                                                Assinantes: {row.number_of_signers}
                                                            </Typography>
                                                            <Typography variant="body2" color="text.secondary">
                                                                Mínimo: {row.signers_minimum}
                                                            </Typography>
                                                            <Chip 
                                                                label={row.signature_type} 
                                                                size="small" 
                                                                color="primary" 
                                                                variant="outlined"
                                                                sx={{ width: 'fit-content' }}
                                                            />
                                                        </Box>
                                                    </ListItem>
                                                    {index < signerList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).length - 1 && <Divider />}
                                                </React.Fragment>
                                            );
                                        })}
                                    </List>
                                )}
                            </Box>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={signerList.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Por página:"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            />
                        </>
                    ) : (
                        // Vista desktop: Tabela sem checkbox, busca e filtro
                        <>
                            <Scrollbar>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                {TABLE_HEAD_SIMPLE.map((headCell) => (
                                                    <TableCell
                                                        key={headCell.id}
                                                        align={headCell.alignRight ? 'right' : 'left'}
                                                        sx={{
                                                            bgcolor: 'grey.100',
                                                            fontWeight: 'fontWeightBold'
                                                        }}
                                                    >
                                                        {headCell.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {signerList.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                                                        <Stack alignItems="center" spacing={2}>
                                                            <Iconify icon="eva:people-outline" sx={{ fontSize: 48, color: 'text.disabled' }} />
                                                            <Typography variant="body2" color="text.secondary">
                                                                Nenhum grupo de assinantes adicionado ainda
                                                            </Typography>
                                                        </Stack>
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                signerList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                                                    return (
                                                        <TableRow hover key={row.group_key}>
                                                            <TableCell component="th" scope="row" padding="normal">
                                                                <Typography variant="subtitle2" noWrap>
                                                                    {row.group_name}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell padding="normal">
                                                                <Typography variant="subtitle2" noWrap>
                                                                    {row.number_of_signers}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell padding="normal">
                                                                <Typography variant="subtitle2" noWrap>
                                                                    {row.signers_minimum}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell padding="normal">
                                                                <Typography variant="subtitle2" noWrap>
                                                                    {row.signature_type}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell align="right">
                                                                <IconButton size="large" color="error" onClick={_ => handleGroupRemove(row.group_key)}>
                                                                    <Iconify icon={'eva:trash-2-outline'} />
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            )}
                                            {emptyRows > 0 && (
                                                <TableRow style={{ height: 53 * emptyRows }}>
                                                    <TableCell colSpan={5} />
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Scrollbar>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={signerList.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </>
                    )}
                </Card>
            </Box>
        </Box>
        </>
    );
}
